const ICONS = {
  cities: <><circle cx="12" cy="10" r="3" /><path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" /></>,
  complexes: <><path d="M4 21V6l8-3 8 3v15" /><path d="M9 9h1M14 9h1M9 13h1M14 13h1M9 17h1M14 17h1M2 21h20" /></>,
  sip: <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></>,
  transfers: <><path d="M8.5 5.5 6 3H3v5l2.5-2.5" /><path d="M6 5.5a7 7 0 0 1 12 3" /><path d="m15.5 18.5 2.5 2.5h3v-5l-2.5 2.5" /><path d="M18 18.5a7 7 0 0 1-12-3" /><path d="M9 9.5a4.5 4.5 0 0 1 6 0M10.5 12a2.25 2.25 0 0 1 3 0" /><circle cx="12" cy="14.5" r=".75" /></>,
  prices: <><circle cx="12" cy="12" r="9" /><path d="M9 7h4a3 3 0 0 1 0 6H9M9 10h5M9 13v5M9 16h5" /></>,
  history: <><path d="M3 12a9 9 0 1 0 3-6.7" /><path d="M3 4v6h6M12 7v5l3 2" /></>,
  operations: <><path d="M9 5h6M9 9h6M9 13h4" /><path d="M7 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10" /><path d="M13 17h8M17 13l4 4-4 4" /></>,
  telegram: <><path d="m22 2-7 20-4-9-9-4Z" /><path d="M22 2 11 13" /></>,
  marketcall: <><path d="M4 4h16v16H4z" /><path d="M8 16V9m4 7V6m4 10v-4" /></>,
  workspace: <><rect x="3" y="7" width="18" height="13" rx="2" /><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18M10 12v2h4v-2" /></>,
  map: <><path d="m3 6 6-3 6 3 6-3v15l-6 3-6-3-6 3Z" /><path d="M9 3v15M15 6v15" /></>,
  sun: <><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.65 17.65l1.42 1.42M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.65 6.35l1.42-1.42" /></>,
  moon: <path d="M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8Z" />,
};

export default function AdminNavIcon({ name }) {
  return (
    <svg className="admin-nav-icon" aria-hidden="true" viewBox="0 0 24 24" focusable="false">
      {ICONS[name] || ICONS.operations}
    </svg>
  );
}
